export const validateRequired = (value) => {
    if (value === '' || value === 'default') {
        return 'Required';
    } else {
        return '';
    }
}
export const validateDrivingLicenseandExpiryDate = (value) => {
    let valid = 0;
    if (value === '') {
        valid = 1;
    }
    if (valid === 0) {
        let d = new Date(value);
         if (d === 'Invalid Date' || !/^\d{1,2}[ ][a-zA-Z]{3}[ ]\d{4}$/.test(value)) {
            valid = 2;
        }
    }

    if (valid === 1) {
        return 'Required';
    } else if (valid === 2) {
        return 'Invalid Date';
    }
    else {
        return '';
    }
}

export const validateDOB = (value) => {
    let valid = 0;
    if (value === '') {
        valid = 1;
    }
    if (valid === 0) {
        let d = new Date(value);

        let todayDate = new Date();
        if (d === 'Invalid Date' || d >= todayDate || !/^\d{1,2}[ ][a-zA-Z]{3}[ ]\d{4}$/.test(value)) {
            valid = 2;
        }
    }

    if (valid === 1) {
        return 'Required';
    } else if (valid === 2) {
        return 'Invalid Date';
    }
    else {
        return '';
    }
}

export const validateWithRegex = (value, regex, message) => {
    const regexObj = new RegExp(regex)
    if (value === '') {
        return 'Required';
    } else if (!regexObj.test(value)) {
        return message === '' ? 'Invalid' : message;
    } else {
        return '';
    }
}

export const validateEmail = (value) => {
    if (value === '') {
        return 'Required'
    //} else if (! /^[^<>()[\]\\,;:%#^\s@"$&!@]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)) {
    } else if (! /^[^<>()[\]\\,;:%#^\s@"$&!@]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,}))$/.test(value)) {
        return 'Invalid Email Address'
    } else {
        return '';
    }
}

export const validateRequiredLettersOnly = (value) => {
    if (value === '') {
        return 'Required';
    } else if (!/^[a-zA-Z ]*$/g.test(value)) {
        return 'Invalid'
    } else {
        return '';
    }
}

export const validateRequiredFiles = (value) => {
    if (value === undefined || value.length === 0) {
        return 'Required';
    } else {
        value.forEach(function (item, index) {
            var re = /(\.jpg|\.jpeg|\.bmp|\.tif|\.pdf|\.gif|\.png)$/i;
            if (!re.exec(item.name)) {
                return 'File extension not supported';
            }
        });
    }
}

export const ValidateRequiredNumbers = (value) => {
    if (value === '') {
        return 'Required'
    } else if (!/^\d+$/.test(value)) {
        return 'Invalid'
    } else {
        return '';
    }
}
export const ValidateYear = (value) => {
    if (value === '') {
        return 'Required'
    } else if (!/^\d{4}$/.test(value)) {
        return 'Invalid Year'
    } else {
        return '';
    }
}
export const ValidateDecimalFormat = (value) => {
    if (value === '') {
        return 'Required'
    } else if (!/(-?[0-9,]+)([.0-9]{3}?)?/.test(value)) {
        return 'Invalid'
    } else {
        return '';
    }
}
export const ValidatePostalNumbers = (value) => {
    if (value === '') {
        return 'Required'
    } else if (!/^\d{6}$/.test(value)) {
        return 'Invalid'
    } else {
        return '';
    }
}

export const ValidateDateFormat = (value) => {
    if (value === '') {
        return 'Required';
    } else if (!Date.parse(value)) {
        return 'Invalid'
    } else {
        return '';
    }
}
export const validateCurrency = (value) => {
    if (!/^(?=.*[1-9])\d{0,5}(\.\d{1,3})?$/.test(value)) {
        return 'Invalid'
    } else {
        return '';
    }
}

export const ValidateRequiredLettersAndNumbers = (value) => {
    if (value === '') {
        return 'Required'
    } else if (!/^[a-z0-9]+$/i.test(value)) {
        return 'Invalid'
    } else {
        return '';
    }
}

export const validateCurrencyInput = (value) => {
    if (!/^[0-9.]+$/i.test(value)) {
        return 'Invalid'
    } else {
        return '';
    }
}
